import { schemes, zSchema } from "@zeal/common";

export const getWorkerAstraUserRequestSchema = zSchema.object({
  worker_id: schemes.mongoObjectId(),
});

export type TGetWorkerAstraUserRequestSchema = zSchema.infer<
  typeof getWorkerAstraUserRequestSchema
>;

export const getWorkerAstraUserResponseSchema = zSchema.object({
  result: zSchema.object({
    env: zSchema.string(),
    id: zSchema.string(),
    tenant: zSchema.string(),
    token: zSchema.string(),
    url: zSchema.string(),
  }),
  worker: zSchema.object({
    access_token: zSchema.string(),
    access_token_expires_at: zSchema.string(),
    astrafi_user_id: zSchema.string(),
    cards: zSchema.array(zSchema.string()),
    createdAt: zSchema.string(),
    odo_user_id: zSchema.string(),
    refresh_token: zSchema.string(),
    refresh_token_expires_at: zSchema.string(),
    updatedAt: zSchema.string(),
    user_id: zSchema.string(),
    user_type: zSchema.string(),
    zeal_id: zSchema.string(),
    is_acknowledged: zSchema.boolean(),
    acknowledged_at: zSchema.string(),
  }),
});

export type TGetWorkerAstraUserResponseSchema = zSchema.infer<
  typeof getWorkerAstraUserResponseSchema
>;
